import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export type AppLocale = "en" | "zh" | "jp";

const loaders: Record<
  AppLocale,
  () => Promise<{ default: Record<string, unknown> }>
> = {
  en: () => import("./en-US.js"),
  zh: () => import("./zh-CN.js"),
  jp: () => import("./ja-JP.js"),
};

function normalizeLanguage(language: string): AppLocale {
  if (language === "zh" || language === "jp" || language === "en") {
    return language;
  }
  return "en";
}

export async function initI18n(language: string): Promise<void> {
  const lng = normalizeLanguage(language);
  const mod = await loaders[lng]();

  if (!i18n.isInitialized) {
    await i18n.use(initReactI18next).init({
      resources: {
        [lng]: {
          translation: mod.default,
        },
      },
      lng,
      fallbackLng: "en",
      interpolation: {
        escapeValue: false,
      },
    });
    return;
  }

  if (!i18n.hasResourceBundle(lng, "translation")) {
    i18n.addResourceBundle(lng, "translation", mod.default, true, true);
  }
  await i18n.changeLanguage(lng);
}

export default i18n;
